// extracted by mini-css-extract-plugin
export var content = "ResetPassword-module__content___lPOHE";